var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getShowCallback),expression:"getShowCallback"}]},[_c('h1',[_vm._v("aaa")]),_vm._v(" "),_c('table-callback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }